/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

// import { filterInit } from "./js_helpers/filterInit";
// import { paginationAjax } from "./js_helpers/paginationAjax";
// import { filterSync } from "./js_helpers/filterActions";
// import { filterUpdate } from "./js_helpers/filterActions";
// import { filterPopState } from "./js_helpers/filterPopState";

// const init_bill_data = JSON.parse(
//   document.getElementById('init_bill_data').textContent
// );

// filterInit(init_bill_data);
// paginationAjax();
// filterSync();
// filterPopState();
// filterUpdate();




import { createRoot } from '@wordpress/element';
import App from './componets/App';

import './bill-single.scss';

const container = document.querySelector('.wp-block-dss-bill-archive');

if (container) {
  const initialData = JSON.parse(
    document.getElementById('init_bill_data').textContent
  );

  createRoot(container).render(
    <App initialData={initialData} />
  );
}


